import React from 'react';
import { FormGroup } from 'reactstrap';
import { RootState } from 'store';
import { useDispatch, useSelector } from 'react-redux';

//SimpleBar
import SimpleBar from 'simplebar-react';

import { Link } from 'react-router-dom';

import '../../components/CommonForBoth/rightbar.scss';
//Import images
import layout1 from 'app/assets/images/layouts/layout-1.jpg';
import layout2 from 'app/assets/images/layouts/layout-2.jpg';
import layout3 from 'app/assets/images/layouts/layout-3.jpg';

import {
  showRightSidebarAction,
  changeLayoutAction,
  changeLayoutWidthAction,
  changeTopbarThemeAction,
  changeSidebarType,
  changeLeftSidebarTheme,
  changePreloader,
} from 'store/Layout';

const RightSidebar = props => {
  const dispatch = useDispatch();
  const {
    layoutType,
    layoutWidth,
    topbarTheme,
    leftSideBarType,
    leftSideBarTheme,
    isPreloader,
  } = useSelector((rootState: RootState) => rootState.layout);
  return (
    <React.Fragment>
      <div className="right-bar">
        <SimpleBar style={{ height: '900px' }}>
          <div data-simplebar className="h-100">
            <div className="rightbar-title px-3 py-4">
              <Link
                to="#"
                onClick={e => {
                  e.preventDefault();
                  dispatch(showRightSidebarAction(false));
                }}
                className="right-bar-toggle float-end"
              >
                <i className="mdi mdi-close noti-icon" />
              </Link>
              <h5 className="m-0">Settings</h5>
            </div>

            <hr className="my-0" />

            <div className="p-4">
              <div className="radio-toolbar">
                <span className="mb-2 d-block">Layouts</span>
                <input
                  type="radio"
                  id="radioVertical"
                  name="radioFruit"
                  value="vertical"
                  checked={layoutType === 'vertical'}
                  onChange={e => {
                    if (e.target.checked) {
                      dispatch(changeLayoutAction('vertical'));
                    }
                  }}
                />
                <label htmlFor="radioVertical">Vertical</label>
                {'   '}
                <input
                  type="radio"
                  id="radioHorizontal"
                  name="radioFruit"
                  value="horizontal"
                  checked={layoutType === 'horizontal'}
                  onChange={e => {
                    if (e.target.checked) {
                      dispatch(changeLayoutAction('horizontal'));
                    }
                  }}
                />
                <label htmlFor="radioHorizontal">Horizontal</label>
              </div>

              <hr className="mt-1" />

              <div className="radio-toolbar">
                <span className="mb-2 d-block" id="radio-title">
                  Layout Width
                </span>
                <input
                  type="radio"
                  id="radioFluid"
                  name="radioWidth"
                  value="fluid"
                  checked={layoutWidth === 'fluid'}
                  onChange={e => {
                    if (e.target.checked) {
                      dispatch(changeLayoutWidthAction('fluid'));
                    }
                  }}
                />
                <label htmlFor="radioFluid">Fluid</label>
                {'   '}
                <input
                  type="radio"
                  id="radioBoxed"
                  name="radioWidth"
                  value="boxed"
                  checked={layoutWidth === 'boxed'}
                  onChange={e => {
                    if (e.target.checked) {
                      dispatch(changeLayoutWidthAction('boxed'));
                    }
                  }}
                />
                <label htmlFor="radioBoxed">Boxed</label>
                <input
                  type="radio"
                  id="radioscrollable"
                  name="radioscrollable"
                  value="scrollable"
                  checked={layoutWidth === 'scrollable'}
                  onChange={e => {
                    if (e.target.checked) {
                      dispatch(changeLayoutWidthAction('scrollable'));
                    }
                  }}
                />
                <label htmlFor="radioscrollable">Scrollable</label>
              </div>
              <hr className="mt-1" />

              <div className="radio-toolbar">
                <span className="mb-2 d-block" id="radio-title">
                  Topbar Theme
                </span>
                <input
                  type="radio"
                  id="radioThemeLight"
                  name="radioTheme"
                  value="light"
                  checked={topbarTheme === 'light'}
                  onChange={e => {
                    if (e.target.checked) {
                      dispatch(changeTopbarThemeAction('light'));
                    }
                  }}
                />
                <label htmlFor="radioThemeLight">Light</label>
                {'   '}
                <input
                  type="radio"
                  id="radioThemeDark"
                  name="radioTheme"
                  value="dark"
                  checked={topbarTheme === 'dark'}
                  onChange={e => {
                    if (e.target.checked) {
                      dispatch(changeTopbarThemeAction('dark'));
                    }
                  }}
                />

                <label htmlFor="radioThemeDark">Dark</label>
                {'   '}
                {layoutType === 'vertical' ? null : (
                  <>
                    {' '}
                    <input
                      type="radio"
                      id="radioThemeColored"
                      name="radioTheme"
                      value="colored"
                      checked={topbarTheme === 'colored'}
                      onChange={e => {
                        if (e.target.checked) {
                          dispatch(changeTopbarThemeAction('colored'));
                        }
                      }}
                    />
                    <label htmlFor="radioThemeColored">Colored</label>{' '}
                  </>
                )}
              </div>

              {layoutType === 'vertical' ? (
                <React.Fragment>
                  <hr className="mt-1" />
                  <div className="radio-toolbar">
                    <span className="mb-2 d-block" id="radio-title">
                      Left Sidebar Type{' '}
                    </span>
                    <input
                      type="radio"
                      id="sidebarDefault"
                      name="sidebarType"
                      value="default"
                      checked={leftSideBarType === 'default'}
                      onChange={e => {
                        if (e.target.checked) {
                          dispatch(changeSidebarType('default'));
                        }
                      }}
                    />
                    <label htmlFor="sidebarDefault">Default</label>
                    {'   '}
                    <input
                      type="radio"
                      id="sidebarCompact"
                      name="sidebarType"
                      value="compact"
                      checked={leftSideBarType === 'compact'}
                      onChange={e => {
                        if (e.target.checked) {
                          dispatch(changeSidebarType('compact'));
                        }
                      }}
                    />
                    <label htmlFor="sidebarCompact">Compact</label>
                    {'   '}
                    <input
                      type="radio"
                      id="sidebarIcon"
                      name="sidebarType"
                      value="icon"
                      checked={leftSideBarType === 'icon'}
                      onChange={e => {
                        if (e.target.checked) {
                          dispatch(changeSidebarType('icon'));
                        }
                      }}
                    />
                    <label htmlFor="sidebarIcon">Icon</label>
                  </div>

                  <hr className="mt-1" />

                  <div className="radio-toolbar">
                    <span className="mb-2 d-block" id="radio-title">
                      Left Sidebar Color
                    </span>
                    <input
                      type="radio"
                      id="leftsidebarThemelight"
                      name="leftsidebarTheme"
                      value="light"
                      checked={leftSideBarTheme === 'light'}
                      onChange={e => {
                        if (e.target.checked) {
                          dispatch(changeLeftSidebarTheme('light'));
                        }
                      }}
                    />

                    <label htmlFor="leftsidebarThemelight">Light</label>
                    {'   '}
                    <input
                      type="radio"
                      id="leftsidebarThemedark"
                      name="leftsidebarTheme"
                      value="dark"
                      checked={leftSideBarTheme === 'dark'}
                      onChange={e => {
                        if (e.target.checked) {
                          dispatch(changeLeftSidebarTheme('dark'));
                        }
                      }}
                    />

                    <label htmlFor="leftsidebarThemedark">Dark</label>
                    {'   '}
                    <input
                      type="radio"
                      id="leftsidebarThemecolored"
                      name="leftsidebarTheme"
                      value="colored"
                      checked={leftSideBarTheme === 'colored'}
                      onChange={e => {
                        if (e.target.checked) {
                          dispatch(changeLeftSidebarTheme('colored'));
                        }
                      }}
                    />

                    <label htmlFor="leftsidebarThemecolored">Colored</label>
                  </div>
                  <hr className="mt-1" />
                </React.Fragment>
              ) : null}

              <FormGroup>
                <span className="mb-2 d-block" id="radio-title">
                  Preloader
                </span>

                <div className="form-check form-switch">
                  <input
                    type="checkbox"
                    className="form-check-input checkbox"
                    id="checkbox_1"
                    checked={isPreloader}
                    onChange={() => {
                      dispatch(changePreloader(!isPreloader));
                    }}
                  />

                  <label className="form-check-label" htmlFor="checkbox_1">
                    Preloader
                  </label>
                </div>
              </FormGroup>

              <h6 className="text-center">Choose Layouts</h6>

              <div className="mb-2">
                <Link
                  to="//skote-v-light.react.themesbrand.com"
                  target="_blank"
                >
                  <img
                    src={layout1}
                    className="img-fluid img-thumbnail"
                    alt=""
                  />
                </Link>
              </div>

              <div className="mb-2">
                <Link to="//skote-v-dark.react.themesbrand.com" target="_blank">
                  <img
                    src={layout2}
                    className="img-fluid img-thumbnail"
                    alt=""
                  />
                </Link>
              </div>

              <div className="mb-2">
                <Link to="//skote-v-rtl.react.themesbrand.com" target="_blank">
                  <img
                    src={layout3}
                    className="img-fluid img-thumbnail"
                    alt=""
                  />
                </Link>
              </div>

              <Link
                to="#"
                className="btn btn-primary btn-block mt-3"
                target="_blank"
              >
                <i className="mdi mdi-cart ms-1" /> Purchase Now
              </Link>
            </div>
          </div>
        </SimpleBar>
      </div>
      <div className="rightbar-overlay" />
    </React.Fragment>
  );
};

export default RightSidebar;
